import type { TFunction } from 'i18next'

export const composeAutoRefreshToggleHelpText = (
  prefixTemplate: string,
  updateIntervalScalar: number,
  updateIntervalUnitTemplate: string,
  t: TFunction<'translation', undefined>
) => `${t(prefixTemplate)} (${updateIntervalScalar} ${t(updateIntervalUnitTemplate)} ${t('general.betweenEachUpdate')})`
